export default class Menu {
    isOpen = false;
    constructor({ el }) {
        this.adminbar = el.querySelector("#wpadminbar");
        this.trigger = el.querySelector(".burger-menu");
        this.main = el.querySelector("main");
        this.header = el.querySelector("header");
        gsap.set(this.main, {
            clipPath: `rect(0% 100% 100% 0%)`
        })

        this.initialize();
    }
    initialize() {
        this.boundClick = this.handleClick.bind(this)
        this.trigger.addEventListener("click", this.boundClick);
        this.refresh();
    }
    refresh() {
        const closeCTA = document.body.querySelector(".wp-block-omnicom-site-menu .close-cta");
        closeCTA.addEventListener("click", () => {
            this.close();
        });
    }
    open() {
        this.isOpen = true;
        return this.enter();
    }
    enter() {
        // this.header.classList.add("entered")
        this.main.classList.add("compact");
        const height = window.innerHeight - this.header.offsetHeight - (this.adminbar ? this.adminbar.offsetHeight : 0);
        const timeline = new gsap.timeline()
        timeline
            .to(this.header, {
                ease: "quint.inOut",
                duration: 1,
                y: height
            }, 'a')
            .to(this.header.querySelector(".header-helper"), {
                ease: "quint.inOut",
                duration: 1,
                "--scale-x": .91666
            }, 'a')
            .to(this.header, {
                ease: "quint.inOut",
                duration: 1,
                "--x": "4.16vw"
            }, 'a')
            .to(this.main, {
                ease: "quint.inOut",
                duration: 1,
                y: height,
                clipPath: `rect(0% 95.84% 100% 4.16%)`
            }, 'a')
            .add(this.overlayEnter(), "a");

        return timeline;
    }
    overlayEnter() {
        const timeline = new gsap.timeline({
            onStart: () => {
                gsap.set(overlay, { autoAlpha: 1})
            }
        });
        const overlay = document.body.querySelector(".wp-block-omnicom-site-menu");
        gsap.set(overlay, { perspective: 800, transformStyle: "preserve-3d" });
        gsap.set(overlay.querySelectorAll(".main-links, .ghost-links"), { perspective: 800, transformStyle: "preserve-3d" });
        const items = overlay.querySelectorAll(`
            .close-cta,
            .main-links a,
            .sub-links,
            .links,
            .copyright
        `)
        timeline.fromTo(items, { alpha: 0, y: 150, z: 200 }, { alpha: 1, y: 0, z: 0, overwrite: true, duration: 0.628, delay: 0.4, stagger: 0.05, ease: "power4.out" });
        return timeline;
    }
    close() {
        this.isOpen = false;
        return this.leave();
    }
    leave() {
        this.main.classList.remove("compact");
        const timeline = new gsap.timeline()
        timeline
            .to(this.header, {
                ease: "quint.inOut",
                duration: 1.2,
                y: 0
            }, 'a')
            .to(this.header.querySelector(".header-helper"), {
                ease: "quint.inOut",
                duration: 1.2,
                "--scale-x": 1
            }, 'a')
            .to(this.main, {
                ease: "quint.inOut",
                duration: 1.2,
                y: 0,
                clipPath: `rect(0% 100% 100% 0%)`
            }, 'a')
            .to(this.header, {
                ease: "quint.inOut",
                duration: 1.2,
                "--x": 0
            }, 'a')

        timeline.add(this.overlayLeave(), 'a')

        return timeline;
    }
    overlayLeave() {
        const timeline = new gsap.timeline({
            onComplete: () => {
                gsap.set(overlay, { autoAlpha: 0})
            }
        });
        const overlay = document.body.querySelector(".wp-block-omnicom-site-menu");
        const items = overlay.querySelectorAll(`
            .close-cta,
            .main-links a,
            .sub-links,
            .links,
            .copyright
        `)
        timeline.to(items, { alpha: 0, y: -150, z: 0, overwrite: true, duration: 0.5, stagger: 0.025, ease: "power4.in" });
        return timeline;
    }
    handleClick(e) {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.enter();
        } else {
            this.leave()
        }
    }
}